import { render, staticRenderFns } from "./matchingQuestion.vue?vue&type=template&id=7f98ec60&"
import script from "./matchingQuestion.vue?vue&type=script&lang=js&"
export * from "./matchingQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f98ec60')) {
      api.createRecord('7f98ec60', component.options)
    } else {
      api.reload('7f98ec60', component.options)
    }
    module.hot.accept("./matchingQuestion.vue?vue&type=template&id=7f98ec60&", function () {
      api.rerender('7f98ec60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/testTaker/matchingQuestion.vue"
export default component.exports